module.exports = __webpack_public_path__ + "static/img/prize2.63e71ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/themes/dragon/img/prize2.png
// module id = wNhn
// module chunks = 1